import React from 'react';
import PropTypes from 'prop-types';
import connect from '../utils/connect';

import { Button, Row, Col, LoadingDots } from '@app/ui';

import userActions from '../actions/user';
import sportsApi from '../utils/sportsApi';
import './GdprConsent.scss';

class GdprConsent extends React.Component {
    state = {
        isSubmitting: false,
        formMessage: {
            type: null,
            text: null,
        },
    };

    _handleClick = async e => {
        e.preventDefault();
        this.setState({ isSubmitting: true });

        const { user, updateUserAgreement } = this.props;
        const payload = {
            action: 'accept_agreements',
            userId: user.id,
        };
        await sportsApi
            .url('/users')
            .json(payload)
            .post()
            .badRequest(error => {
                const response = JSON.parse(error.message);

                this.setState({
                    formMessage: {
                        type: 'dan',
                        text: response.message,
                    },
                    isSubmitting: false,
                });
            })
            .res(() => {
                this.setState({
                    formMessage: {
                        type: 'suc',
                        text: 'You have successfully agreed to our updated terms and services. This window will go away soon...',
                    },
                    isSubmitting: false,
                });

                setTimeout(() => updateUserAgreement(), 2000);
            });
    };

    render() {
        const { formMessage, isSubmitting } = this.state;

        return (
            <Row gutter={16} className="overlay">
                <Col span={24}>
                    <div
                        className="gds-modal--shown"
                        data-element="modal-example"
                    >
                        <div className="gds-modal gds-layout__column--md-12">
                            <div className="gds-modal__header">
                                <h2 className="gds-modal__title gds-text--header-sm">
                                    GDPR Compliance Updates
                                </h2>
                            </div>
                            <div className="gds-modal__body">
                                <p className="-text-center -m-b-3 -p-h-4 -p-h-0-md">
                                    We have recently made updates to{' '}
                                    <a
                                        href="https://scoreboard.gumgum.com/terms-and-services"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="gds-text--link gds-text--bold -cursor--pointer"
                                    >
                                        our Terms of Use
                                    </a>{' '}
                                    and{' '}
                                    <a
                                        href="https://gumgum.com/privacy-policy"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="gds-text--link gds-text--bold -cursor--pointer"
                                    >
                                        Privacy Policy
                                    </a>{' '}
                                    in support of our compliance with GDPR.
                                    Please take a moment to review these updated
                                    terms. Should you have any questions about{' '}
                                    {`GumGum's`} GDPR readiness, please contact
                                    us at: legal@gumgum.com.
                                </p>
                            </div>
                            {formMessage.text && (
                                <small className="gds-form-group -text-center -color-tx-dan">
                                    {formMessage.text}
                                </small>
                            )}
                            <div className="gds-modal__footer -text-center">
                                <Button
                                    block
                                    variant="primary"
                                    disabled={isSubmitting}
                                    style={{
                                        color: 'white',
                                        minHeight: '51px',
                                        minWidth: '160px',
                                    }}
                                    onClick={this._handleClick}
                                >
                                    {isSubmitting ? <LoadingDots /> : 'I Agree'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
}

GdprConsent.propTypes = {
    user: PropTypes.object.isRequired,
    updateUserAgreement: PropTypes.func.isRequired,
};

export default connect(['user'], userActions)(GdprConsent);
